/* global axios */
import ApiClient from './ApiClient';

// Il wizard MTProto e' a tre chiamate perche' il phone_code_hash restituito da
// Telegram e' legato alla connessione che lo ha generato: il sidecar tiene vivo
// il client tra un passo e l'altro e qui ci limitiamo a passare il loginId.
class TelegramUserAPI extends ApiClient {
  constructor() {
    super('telegram_user/authorization', { accountScoped: true });
  }

  requestCode(phoneNumber) {
    return axios.post(`${this.url}/request_code`, {
      phone_number: phoneNumber,
    });
  }

  verifyCode({ loginId, code, syncSettings }) {
    return axios.post(`${this.url}/verify_code`, {
      login_id: loginId,
      code,
      sync_settings: syncSettings,
    });
  }

  verifyPassword({ loginId, password, syncSettings }) {
    return axios.post(`${this.url}/verify_password`, {
      login_id: loginId,
      password,
      sync_settings: syncSettings,
    });
  }

  // Entra in un gruppo da un link d'invito con l'account dell'inbox indicata. La rotta
  // sta sotto telegram_user/, non sotto telegram_user/authorization.
  joinGroup({ inboxId, invite }) {
    const base = this.url.replace(/\/authorization$/, '');
    return axios.post(`${base}/join`, { inbox_id: inboxId, invite });
  }
}

export default new TelegramUserAPI();
